"use client";

import Image from "next/image";
import styles from "../../styles/pages/Rooms.module.scss";
import Link from "next/link";
import Topbanner from "../Topbanner/Topbanner";
import { roomsData } from "../../data/roomsData";
import { useEffect, useState, Suspense } from "react";
import NewLoader from "../Loader/NewLoader";
import { useRouter, useSearchParams } from "next/navigation";
import moment from "moment";
import { addDays, differenceInDays } from "date-fns";
import BreadCrumbSchema from "../Schema/HotelSchema/breadcrumb";
import AccomodationSchema from "../Schema/HotelSchema/accomodation";

function RoomsInner() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [loader, setLoader] = useState(false);
  const [noOfNights, setNoOfNights] = useState(
    searchParams.get("npOfNights") || 1,
  );
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(() => {
    const tomorrow = addDays(new Date(), 1);
    return tomorrow;
  });

  const [checkin, setCheckin] = useState({
    day: searchParams.get("checkInDay") || "",
    month: searchParams.get("checkInMonth") || "",
    year: searchParams.get("checkInYear") || "",
  });

  const [checkout, setCheckout] = useState({
    day: searchParams.get("checkOutDay") || "",
    month: searchParams.get("checkOutMonth") || "",
    year: searchParams.get("checkOutYear") || "",
  });

  useEffect(() => {
    const updateDateState = (date, setStateFunction) => {
      if (date !== null) {
        const day = date.getDate();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        setStateFunction({ day, month, year });
      }
    };

    updateDateState(startDate, setCheckin);
    updateDateState(endDate, setCheckout);

    const nights = moment(endDate).diff(moment(startDate), "days");
    setNoOfNights(nights > 0 ? nights : 1);
  }, [startDate, endDate]);

  useEffect(() => {
    const nights = differenceInDays(endDate, startDate);
    setNoOfNights(nights);
  }, [startDate, endDate]);

  const formated_start_date = moment(startDate).format("YYYY-MM-DD");
  const formated_end_date = moment(endDate).format("YYYY-MM-DD");

  const handleSubmit = async (event, hotelId) => {
    event.preventDefault();

    setLoader(true);

    try {
      await router.push(
        `/searchresult/?hotelID=${hotelId}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=1&adult=2&children=0&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}`
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <NewLoader />}
      <Topbanner
        bgImage={"/images/our-rooms-banner.png"}
        title={"Explore the best Room Suites"}
      />
      <section className={`${styles.rooms} common_padding`}>
        <div className="container">
          {roomsData.map((room, index) => (
            <div
              className={`${styles.rooms_main} row align-items-center`}
              key={index}
            >
              <div className={`${styles.rooms_left} col-md-4`}>
                <img src={room.roomsImage} alt={room.roomName} />
              </div>
              <div className={`${styles.rooms_center} col-md-5 common_title`}>
                <h2>{room.roomName}</h2>
                <p className={styles.rooms_center_desc}>{room.roomDesc}</p>
                <div className={styles.rooms_center_amen}>
                  <div>
                    <Image
                      src="/icons/bed.svg"
                      height={20}
                      width={23}
                      alt="bed-icon"
                    />
                  </div>
                  <div className={styles.right_amen}>
                    <Image
                      src="/icons/guests.svg"
                      height={20}
                      width={23}
                      alt="guests-icon"
                    />
                  </div>
                  <div className={styles.right_amen}>
                    <Image
                      src="/icons/coffee.svg"
                      height={20}
                      width={23}
                      alt="coffee-icon"
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles.rooms_right} col-md-3 common_title`}>
                <button
                  className="common_btn"
                  onClick={(event) => handleSubmit(event, 17)}
                >
                  Book Now
                </button>
                <Link
                  className="secound_common_btn"
                  href={`/hotel-room-in-shimla/${room.slug}`}
                >
                  More Details
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      <BreadCrumbSchema />
      <AccomodationSchema />
    </>
  );
}

export default function Rooms(props) {
  return (
    <Suspense fallback={null}>
      <RoomsInner {...props} />
    </Suspense>
  );
}
